import { z } from 'zod';

export const MODULE_KEYS = [
  'accounting',
  'pipeline_tracking',
  'call_reports',
  'reporting',
  'crm',
  'admin_tasks',
  'workflows',
  'mana_pricing',
] as const;
// Retired keys — no page, nav entry or permission editing; the permission rows users still
// hold for them are inert. Both were replaced by Mana Pricing and decommissioned 2026-10-11:
//  - 'pricing': the UWM-only Pricing module
//  - 'other_lenders_pricing': the rate-sheet Other Lenders Pricing module

export type ModuleKey = (typeof MODULE_KEYS)[number];

export const ModuleKeySchema = z.enum(MODULE_KEYS);

export const MODULE_LABELS: Record<ModuleKey, string> = {
  accounting: 'Accounting',
  pipeline_tracking: 'My Pipeline',
  call_reports: 'Call Reports',
  reporting: 'Reporting',
  crm: 'My CRM',
  admin_tasks: 'Admin Tasks',
  workflows: 'Workflows',
  mana_pricing: 'Mana Pricing',
};

// Modules with a full UI. Others are placeholders.
export const PHASE_1_ENABLED_MODULES: readonly ModuleKey[] = [
  'pipeline_tracking',
  'workflows',
  'crm',
  'mana_pricing',
];

/**
 * Modules a new signup does NOT get. Empty since the Mana Pricing cutover of 2026-10-11 (Mana
 * Pricing was held here while it was admin-only; everyone with Pricing or Other Lenders Pricing
 * was then granted it with scripts/grant-mana-pricing.ts). Kept so a future module can again
 * start admin-only.
 */
export const MODULES_HELD_FROM_SIGNUP: readonly ModuleKey[] = [];

export const isPhase1Enabled = (key: ModuleKey): boolean =>
  PHASE_1_ENABLED_MODULES.includes(key);
